import { PackageNameEnum } from '@electricjs/core_entity-client';
import type { TFunction } from 'i18next';

import { PackageFeatures } from './types';

export const FEATURES_BY_PLAN = {
  [PackageNameEnum.Pro]: [
    PackageFeatures.DeviceManagement,
    PackageFeatures.DeviceProcurement,
    PackageFeatures.EmployeeManagement,
    PackageFeatures.AppManagement,
    PackageFeatures.EmployeeSupport,
  ],
  [PackageNameEnum.Lyte]: [
    PackageFeatures.DeviceProcurement,
    PackageFeatures.EmployeeManagement,
    PackageFeatures.AppManagement,
    PackageFeatures.EmployeeSupport,
  ],
};

export const getFeatureDisplayNameMap = (t: TFunction) => ({
  [PackageFeatures.DeviceManagement]: t(
    'onboardings.licenseFeatures.deviceManagement'
  ),
  [PackageFeatures.DeviceProcurement]: t(
    'onboardings.licenseFeatures.deviceProcurement'
  ),
  [PackageFeatures.EmployeeManagement]: t(
    'onboardings.licenseFeatures.employeeManagement'
  ),
  [PackageFeatures.AppManagement]: t(
    'onboardings.licenseFeatures.appManagement'
  ),
  [PackageFeatures.EmployeeSupport]: t(
    'onboardings.licenseFeatures.employeeSupport'
  ),
});
